import React from 'react';
import { useState } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

interface CustomAlertProps {
  message: string;
  severity: 'error' | 'warning' | 'info' | 'success';
}

const severityTitles: { [key in CustomAlertProps['severity']]: string } = {
  error: 'Erro',
  warning: 'Atenção',
  info: 'Informativo',
  success: 'Sucesso',
};

export const CustomAlert: React.FC<CustomAlertProps> = ({ message, severity }) => {
  const [openAlert, setOpenAlert] = useState(true);

  const handleClose = () => {
    setOpenAlert(false);
  };

  return (
    <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
      <Alert severity={severity} variant="filled" onClose={handleClose}>
        <AlertTitle>{severityTitles[severity]}</AlertTitle>
        {message}
      </Alert>
    </Snackbar>
  );
};